module.exports = __webpack_public_path__ + "static/aplicativoMobes-dca75c92eb08b566ee58894156fa6a1c.png";